export const notifications = {
    error(message) {
        return {
            title: 'Error',
            message: message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        };
    },
    success(message) {
        return {
            title: 'Success',
            message,
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        }
    },
};



// WEBPACK FOOTER //
// ./app/components/TcIndex/common.js